module.exports = __webpack_public_path__ + "static/delivery-391f4da677d14c7dd8dc21af1a743b1b.jpg";